module.exports = __webpack_public_path__ + "static/media/errorback.abf69d2d.jpg";